var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-login" }, [
    _c("h5", [_vm._v("Grave uma nova senha")]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "m-t",
        attrs: {
          role: "form",
          method: "post",
          action: _vm.opts.change_pass_url
        }
      },
      [
        _c("input", { attrs: { name: "utf8", type: "hidden", value: "✓" } }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "_method", value: "put" }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "authenticity_token" },
          domProps: { value: _vm.opts.form_token }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "user[reset_password_token]" },
          domProps: { value: _vm.opts.reset_password_token }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "error text-danger",
          domProps: { innerHTML: _vm._s(_vm.opts.html_errors) }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary block full-width m-b",
            attrs: { type: "submit" }
          },
          [_vm._v("Alterar senha")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c(
        "label",
        {
          staticClass: "password required",
          staticStyle: { width: "100%", "text-align": "left !important" },
          attrs: { id: "user_password", for: "user_password" }
        },
        [_vm._v("Nova senha")]
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: {
          type: "password",
          placeholder: "Senha",
          required: "",
          name: "user[password]"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c(
        "label",
        {
          staticClass: "password required",
          staticStyle: { width: "100%", "text-align": "left !important" },
          attrs: { id: "user_password", for: "user_password" }
        },
        [_vm._v("Redigite a nova senha")]
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: {
          type: "password",
          placeholder: "Senha",
          required: "",
          name: "user[password_confirmation]"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }